import { StyleSheet } from 'aphrodite';
import { children, media, palette } from 'util/style-helpers';

interface Options {
  tabs: number;
}

export const style = (options: Options) => {
  const { tabs } = options;

  return StyleSheet.create({
    main: {
      flexGrow: 1,
      padding: '30px 20px',
    },
    featuredSessions: {
      maxWidth: '940px',
      margin: '0 auto',
      marginBottom: 15,

      [media.tablet]: {
        marginBottom: 55,
      },
      [media.desktop]: {
        marginBottom: 60,
      },
    },
    featuredHeader: {
      color: palette.white,
      background: palette.red,
      padding: 20,
      textAlign: 'center',
      fontSize: 14,

      [children('> h1')]: {
        fontSize: 'inherit',
      },

      [media.tablet]: {
        fontSize: 20,
      },
      [media.desktop]: {
        fontSize: 24,
      },
    },
    featuredVideoTileContainer: {
      [media.desktop]: {
        justifyContent: 'center',
        [children('> article')]: {
          padding: '0 30px',
        },
      },
    },
    categories: {
      maxWidth: '940px',
      margin: '0 auto',
    },
    content: {
      padding: '18px 0px',
      [media.tablet]: {
        padding: '36px 30px',
        backgroundColor: 'rgb(0, 0, 0, 0.2)',
      },
      [media.desktop]: {},
    },
    tabs: {
      width: '100%',
      display: 'flex',
      backgroundColor: 'transparent',
      borderBottom: '5px solid ' + palette.red,
      fontSize: '14px',
      lineHeight: '18px',
      textAlign: 'center',
      color: 'white',
      [media.tablet]: {
        fontSize: '20px',
        lineHeight: '24px',
      },
      [media.desktop]: {
        fontSize: '24px',
        lineHeight: '29px',
      },
    },
    tab: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      padding: '10px 15px',
      textDecoration: 'none',
      color: 'inherit',
      backgroundColor: palette.lightDarkGrey,
      width: `calc((100% - ${tabs - 1} * 5px)/${tabs})`,
      transition: 'font-weight 0.1s linear',
      ':not(:last-child)': {
        marginRight: '5px',
      },
      ':hover': {
        fontWeight: 'bold',
      },
      [media.tablet]: {
        padding: '22px 25px',
        width: `calc((100% - ${tabs - 1} * 10px)/${tabs})`,
        ':not(:last-child)': {
          marginRight: '10px',
        },
      },
      [media.desktop]: {
        padding: '20px 33px',
        width: `calc((100% - ${tabs - 1} * 12px)/${tabs})`,
        ':not(:last-child)': {
          marginRight: '12px',
        },
      },
    },
    selected: {
      backgroundColor: palette.red,
      fontWeight: 'bold',
      cursor: 'default',
    },
    videoGrid: {
      margin: '0 auto',

      [media.desktop]: {
        maxWidth: 875,
      },
    },
    videoTileContainer: {
      margin: '0 -15px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      maxWidth: 980,

      [children('> div')]: {
        marginBottom: 30,
      },

      [media.desktop]: {
        justifyContent: 'flex-start',
        [children('> div')]: {
          marginBottom: 25,
        },
      },
    },
    carousel: {
      margin: '10px auto 0 auto',
      [media.desktop]: {
        marginTop: '45px',
      },
    },
  });
};
